/**
 * @ngdoc directive
 * @module components.anchor
 * @name components.anchor:anchor
 * @scope
 * @restrict E
 * @description
 * A link that scrolls to a section of the page when clicked. Must be nested within the [anchorContainer](/docs/api/components.anchor:anchorContainer) component. It also has an optional dependency on the sticky component. This is only used to ensure the correct 
 * @param {string} target The anchor target the link will scroll to when clicked.
 * @example
    <example module="dataExample">
        <file name="index.html">
            <div ng-controller="exampleController">
                <anchor-container scroll-target="#content">
                    <anchor class="button" target="{{anchor.name}}" ng-repeat="anchor in anchors">{{anchor.name}}</anchor>
                </anchor-container>
                <div id="content" style="height: 600px; overflow: auto;">
                    <div anchor-target="{{content.name}}" ng-repeat="content in anchors">
                        <h3>{{content.name}}</h3>
                        <div ng-bind-html="content.text|trustAsMarkup"></div>
                    </div>
                </div>
            </div>
        </file>
        <file name="script.js">
            (function() {
                angular.module('dataExample', ['components.anchor', 'utility'])
                    .controller('exampleController', exampleController);

                exampleController.$inject = ['$scope'];
                function exampleController($scope) {
                    $scope.anchors = [];
                    for (var i=1; i<5; i++) {
                        $scope.anchors.push({
                            name: 'Anchor ' + i,
                            text: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi blandit quam sit amet metus tincidunt rutrum. Pellentesque ut luctus nisl. Quisque commodo risus a lacinia rhoncus. Duis molestie sem vitae feugiat sollicitudin. Vestibulum sit amet aliquet turpis. Nam elit lacus, viverra et scelerisque sed, volutpat eu magna. Sed ultrices felis risus. Sed a dapibus quam.</p><p>Etiam tincidunt enim a dui congue, id semper eros volutpat. Aenean elementum orci dolor, at semper eros sollicitudin eu. Quisque eu mi et nunc venenatis faucibus euismod quis tortor. Praesent auctor tellus id pulvinar semper. Integer ultrices ligula eu magna condimentum cursus. Mauris facilisis sapien eu magna feugiat imperdiet. Nulla luctus lacus eu lobortis scelerisque. Morbi tristique turpis nec magna condimentum, tristique congue lectus mattis. Maecenas eu massa eleifend, gravida arcu quis, dignissim diam. Vestibulum pulvinar est ut euismod maximus. Quisque et est diam. Sed finibus nisi id tellus sodales, at tristique metus malesuada.</p>'
                        });
                    }
                }
            })();
        </file>
    </example>
 */
(function () {
    angular.module('components.anchor', [])
        .component('anchor', {
            require: {
                container: '^anchorContainer',
                stickyManager: '^?stickyManager'
            },
            bindings: {
                target: '@'
            },
            controller: anchorController
        });

    anchorController.$inject = ['$element', '$timeout'];
    function anchorController($element, $timeout) {
        var ctrl = this;

        ctrl.$postLink = function () {
            $timeout(function () {
                ctrl.$target = angular.element('[anchor-target="' + ctrl.target + '"]');
                ctrl.container.register(ctrl);
            });
            $element.on('click.anchor', function () {
                ctrl.$$scrollToTarget(false);
            });
        }

        ctrl.isPassed = function () {
            var topOffset = (ctrl.container.scrollTarget ? ctrl.container.$scrollTarget.offset().top : 0) + (ctrl.stickyManager ? ctrl.stickyManager.getStickPoint() : 0);
            var targetOffset = ctrl.$target[0].getBoundingClientRect();
            return targetOffset.top - topOffset <= 0;
        };

        ctrl.$$scrollToTarget = function (skipAnimation) {
            (ctrl.container.scrollTarget ? ctrl.container.$scrollTarget.offset().top : angular.element('body,html')).stop().animate({
                scrollTop: (ctrl.container.scrollTarget ? '+=' : '') + (ctrl.$target.offset().top - (ctrl.container.scrollTarget ? ctrl.container.$scrollTarget.offset().top : 0) - (ctrl.stickyManager ? ctrl.stickyManager.getStickPoint() : 0) + 1)
            }, skipAnimation ? 10 : 600);
        };

        ctrl.setActive = function (isActive) {
            if (isActive) {
                $element.addClass(ctrl.container.activeClass || 'active');
            }
            else {
                $element.removeClass(ctrl.container.activeClass || 'active');
            }
        }

        ctrl.$onDestroy = function () {
            $element.off('click.anchor');
        };
    }
})();